import styled from '../../../theme'
import is from 'typescript-styled-is'
import { IWithSize } from '../../BookingCalendar/Calendar/Calendar'

export const PriceSectionLabel = styled.span`
  font-weight: bold;
`
export const ChosenCurrencyValue = styled.span`
  font-weight: bold;
  color: #00a541;
`

export const InfoLabel = styled.span`
  font-size: 1rem;
  color: #5e5d5e;
`

export const Label = styled.span<IWithSize>`
  color: #696a6d;
  font-size: ${({ size }) => (size ? 0.9 * size : 0.9)}rem;
`

export const SectionTitle = styled.span<IWithSize>`
  color: #696a6d;
  font-size: ${({ size }) => (size ? 0.9 * size : 0.9)}rem;
  font-weight: 600;
`

export const PreviewContainer = styled.div<IWithSize & { error?: boolean }>`
  width: auto;
  height: auto;
  padding: ${({ size }) =>
  size ? `${15 * size}px ${12 * size}px` : '15px 12px'};
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2),
    0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 0px -1px rgba(0, 0, 0, 0.12);
  ${is('error')`
  	outline: #f96868 solid 1px;
  `}
`
